<template>
    <div class="box">
        <div class="header">
			<!-- logo -->
            <div class="logo pointer" @click="return_fn">
				<img src="../static/images/logo.png" alt="">
            </div>
			<!-- 头部右侧 -->
            <div class="header_right">
				<!-- 登入/注册 -->
                <div v-if="!user_data && !return_" @click="login" class="btnbox pointer">
                    <div class="user_icon">
                        <img class="ren" src="../static/images/user_icon.png" alt="">
                    </div>
                    <span class="login_text">{{$t('m.index_13')}}</span>
                </div>
				<!-- 返回主页 -->
                <div v-if="user_data && return_" @click="user_back" class="btnbox pointer">
                    <div class="hostbox">
                        <img src="../static/images/host_icon.png" alt="">
                    </div>
					<div class="user_portrait aa">
					    <img :src="user_data.head_pic" alt="">
						<div style="width: 0.5rem;"></div>
						<div>
							<img class="san" src="../static/caidan.png" alt="">
							<span>{{$t('m.index_12')}}</span>
						</div>
						<!-- <img src="../static/caidan1.png" alt=""> -->
					</div>
                    <span class="cc">{{$t('m.index_12')}}</span>
                </div>
				<!-- 已登录 -->
                <div v-if="user_data && !return_" class="btnbox pointer" @click="user_info">
                    <div class="user_portrait">
                        <img :src="user_data.head_pic" alt="">
                    </div>
                    <div class="username">{{ user_data.nickname }}</div>
                    <div class="youjiantou flex f-ct">
                        <img src="../static/baisejiantou.png" alt="">
                    </div>
                </div>
				<!-- 语言转换 -->
                <div class="btnbox1 pointer" @click="chang_lang">
                    <div class="user_icon">
                        {{ langtext }}
                    </div>
                    <span class="login_text">{{langtext1}}</span>
                </div>

            </div>
        </div>
		<!-- 绝对定位做留空 -->
        <div class="header_kongbox"></div>
    </div>
</template>
<script>
import Cookies from 'js-cookie';
import { Loading } from 'element-ui';
let loading;
export default {
    data() {
        return {
            lang: 2,
            langtext: '中',
            langtext1: '简体中文',
            user_data:{},
        }
    },
    props: {
        return_: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.user_data = JSON.parse(localStorage.getItem('user_data'))
        let lang = Cookies.get('lang')
        this.lang = lang
        if (lang == 2) {
            this.langtext = 'EN'
            this.langtext1='English'
        } else {
            
			
			this.langtext = '中'
			this.langtext1='简体中文'
        }
    },
    methods: {
		// uers页面的返回
		user_back(){
			// 判断显示屏宽
			var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
			if(is_h5>1200){
				this.return_fn()
			}else{
				this.$emit('backf')
			}
		},
        chang_lang() {
			let lang = Cookies.get('lang')
			var title = '拼命加载中...'
			if(lang==1){
				title = 'Loading...'
			}
			// loading = Loading.service({
			// 	spinner: 'el-icon-loading',
			// 	lock: true,
			// 	text: title,
			// 	background: 'rgba(255,255,255,0.5)',
			// 	target: document.querySelector('.content')
			// })
			
			
			
            // console.log(this.$i18n.locale)
            // let lang = Cookies.get('lang')
            if (lang == 2) {
                this.$i18n.locale = 'en-US'
                this.lang == 1
                this.langtext = 'en'
                this.langtext1='English'
                Cookies.set("lang", '1')
            } else {
                this.$i18n.locale = 'zh-CN'
                this.lang == 2
                this.langtext = '中'
                this.langtext1='简体中文'
                Cookies.set("lang", '2')
            }
			
			// loading.close();
            setTimeout(()=>{
				this.$router.go(0)
			},100)
        },
        login() {
            this.$router.push({
                path: '/account/login'
            })
        },
        return_fn() {
            this.$router.push({
                path: '/'
            })
        },
        user_info() {
            this.$router.push({
                path: '/user/userhome'
            })
        },
    },
}
</script>

<style scoped lang="scss">
// 宽度小于1200px
@media screen and (min-width: 1200px){
	.header_kongbox{
		height: 90px;
	}
	.header {
		width: 100%;
		height: 90px;
		background-color: #FFF;
		display: flex;
		justify-content: space-between;
		padding-left: 145px;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		box-shadow: 0 1px 6px #ddd;
		.logo {
			img {
				width: 90px;
				// height: 61px;
			}
		}
		.header_right {
			display: flex;
			align-items: center;
			.login_text {
				letter-spacing: 2px;
			}
			.btnbox {
				width: 300px;
				height: 90px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #005efc;
				.user_portrait {
					width: 54px;
					height: 54px;
					background-color: #fff;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 50px;
						height: 50px;
						border-radius: 50%;
					}
				}
				.username {
					color: #fff;
					font-weight: bold;
					font-size: 16px;
					margin-left: 10px;
				}
				.youjiantou {
					margin-left: 24px;

					img {
						width: 9px;
						height: 13px;
					}
				}
				.user_icon {
					width: 30px;
					height: 30px;
					border-radius: 5px;
					background-color: #FFF;
					text-align: center;
				}
				.hostbox {
					img {
						width: 33px;
						height: 33px;
					}
				}
				span {
					color: #fff;
					font-weight: bold;
					font-size: 17px;
					margin-left: 10px;
				}
			}
			.btnbox1 {
				width: 300px;
				height: 90px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #ecf2fd;
				.user_icon {
					width: 30px;
					height: 30px;
					border-radius: 5px;
					background-color: #005efc;
					line-height: 30px;
					text-align: center;
					color: #FFF;
					font-weight: bold;
					box-shadow: 0 0 30px #87b3fd;
					font-size: 15px;
				}
				span {
					color: #005efc;
					font-weight: bold;
					font-size: 17px;
					margin-left: 10px;
				}
			}
		}
	}
	.ren{
		margin-top: 7px;
		width: 16px;
		height: 16px;
	}
	.aa{
		display: none!important;
	}
}


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.box{
		width: 100%;
		overflow: hidden;
		.header_kongbox{
			height: 2.5rem;
		}
		.header{
			width: 100%;
			height: 2.5rem;
			position: fixed;
			box-shadow: 0 1px 6px #ddd;
			top: 0;
			left: 0;
			z-index: 10;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #fff;
			padding: 0rem 0.5rem;
			// padding-right: 0.5rem;
			.logo{
				img{
					width: 2.275rem;
					display: block;
				}
			}
			.header_right{
				display: flex;
				align-items: center;
				.btnbox{
					margin-right: 0.4rem;
					.user_icon{
						margin: auto;
						img{
							width: 0.8rem;
							height: 0.8rem;
							// border-radius: 50%;
							margin: auto;
							margin-bottom: 0.15rem;
							// margin-right: 0.4rem;
							display: block;
						}
					}
					.hostbox{
						display: none;
					}
					.aa{
						display: block;
					}
					.cc{
						display: none;
					}
					.user_portrait{
						display: flex;
						justify-content: center;
						img{
							width: 1.05rem;
							height: 1.05rem;
							border-radius: 50%;
							display: block;
							margin: auto;
							.san{
								// margin-left: 0.3rem;
								margin-top: 0.1rem;
								width: 1.65rem;
								height: 1.65rem;
								display: block;
								// margin: auto!important;
							}
						}
					}
					.username{display: none;}
					.youjiantou{display: none;}
					>span{
						// display: none;
					}
					// .ren{
					// 	display: block;
					// 	margin: auto;
					// }
				}
				.btnbox1{
					// display: none;
					.user_icon {
						width: 26px;
						height: 26px;
						border-radius: 5px;
						background-color: #005efc;
						line-height: 26px;
						text-align: center;
						color: #FFF;
						font-weight: bold;
						box-shadow: 0 0 30px #87b3fd;
						font-size: 15px;
						margin: auto;
					}
					.login_text{
						// display: none;
					}
				}
			}
		}
	}	
}
</style>